export default __webpack_public_path__ + "static/media/fevr-tokens-hero.1ecaff57.png";